import React, { lazy, Suspense } from "react";

export default function DynamicLegalWording({ filePath }) {
    const DynamicComponent = lazy(() => import(`${filePath}`));
    return (
        <Suspense >
            <DynamicComponent />
        </Suspense>
    );
}